import { Grid, Stack, Text } from '@mantine/core';
import AumAndFreshnessCard from 'src/connected-assets/components/AumAndFreshnessCard';
import CoverageCard from 'src/connected-assets/components/CoverageCard';
import ProviderChart from 'src/connected-assets/components/ProviderChart';
import type { ProviderCoverage } from 'src/connected-assets/types';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

const MOCK_PROVIDERS: ProviderCoverage[] = [
  {
    provider: 'Standard Life',
    valuationsProvider: 'FINIO',
    matchedCount: 45,
    unmatchedCount: 5,
    matchedAum: 12_500_000,
    unmatchedAum: 1_200_000,
    lastSync: '2026-03-10T10:30:00Z',
    health: 'HEALTHY',
  },
  {
    provider: 'Prudential',
    valuationsProvider: 'ORIGO',
    matchedCount: 32,
    unmatchedCount: 21,
    matchedAum: 8_400_000,
    unmatchedAum: 5_600_000,
    lastSync: '2026-03-10T09:15:00Z',
    health: 'HEALTHY',
  },
  {
    provider: 'Aegon',
    valuationsProvider: 'FINIO',
    matchedCount: 18,
    unmatchedCount: 12,
    matchedAum: 3_200_000,
    unmatchedAum: 2_100_000,
    lastSync: '2026-03-08T14:00:00Z',
    health: 'DELAYED',
  },
  {
    provider: 'Aviva',
    valuationsProvider: 'ORIGO',
    matchedCount: 28,
    unmatchedCount: 0,
    matchedAum: 6_800_000,
    unmatchedAum: 0,
    lastSync: '2026-03-10T11:00:00Z',
    health: 'HEALTHY',
  },
  {
    provider: 'Scottish Widows',
    valuationsProvider: 'FINIO',
    matchedCount: 15,
    unmatchedCount: 8,
    matchedAum: 4_100_000,
    unmatchedAum: 1_800_000,
    lastSync: '2026-03-10T08:45:00Z',
    health: 'HEALTHY',
  },
];

export default function ConnectedAssetsSandbox() {
  return (
    <Stack gap="xl">
      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        CoverageCard
      </Text>
      <Grid>
        <Grid.Col span={4}>
          <CoverageCard
            matchedProducts={0}
            totalFeedProducts={80}
            unmatchedProducts={80}
            coveragePercentage={0}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <CoverageCard
            matchedProducts={68}
            totalFeedProducts={120}
            unmatchedProducts={52}
            coveragePercentage={56.67}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <CoverageCard
            matchedProducts={42}
            totalFeedProducts={42}
            unmatchedProducts={0}
            coveragePercentage={100.0}
          />
        </Grid.Col>
      </Grid>

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        AumAndFreshnessCard
      </Text>
      <Grid>
        <Grid.Col span={4}>
          <AumAndFreshnessCard
            connectedAum={42_300_000}
            healthyProviderCount={11}
            totalProviderCount={12}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <AumAndFreshnessCard
            connectedAum={850_000}
            healthyProviderCount={2}
            totalProviderCount={5}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <AumAndFreshnessCard connectedAum={0} healthyProviderCount={0} totalProviderCount={3} />
        </Grid.Col>
      </Grid>

      <Text size="lg" fw={FONT_WEIGHTS.semibold}>
        ProviderChart
      </Text>
      <Grid>
        <Grid.Col span={4}>
          <ProviderChart providers={MOCK_PROVIDERS} />
        </Grid.Col>
        <Grid.Col span={4}>
          <ProviderChart
            providers={MOCK_PROVIDERS.map(p => ({ ...p, unmatchedCount: 0, unmatchedAum: 0 }))}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <ProviderChart providers={[]} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
